/* Bloc Klarna Rog. Lit le total affiché dans la carte « Votre configuration ».
   3 fois affiché seulement en France et sous 3 000 € (plafond constaté chez Klarna le 29/09/2026). */
(function () {
  var data = document.getElementById('rog-klarna-data');
  if (!data) return;
  var cfg; try { cfg = JSON.parse(data.textContent); } catch (e) { return; }
  var T = cfg.t || {}; if (!T.tg) return;
  var PLAFOND = 3000;
  var fmt = new Intl.NumberFormat((cfg.locale || 'fr') + '-' + (cfg.pays || 'FR'), { style: 'currency', currency: 'EUR' });
  var chev = '<svg viewBox="0 0 10 10" aria-hidden="true"><path d="M3.5 1.5 7 5l-3.5 3.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var croix = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 2l8 8M10 2 2 10" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

  function montant(txt) {
    var s = String(txt || '').replace(/[^\d.,]/g, '');
    if (!s) return 0;
    var m = s.match(/[.,](\d{2})$/);
    var dec = m ? m[1] : '';
    var ent = (m ? s.slice(0, -3) : s).replace(/[.,]/g, '');
    return parseFloat(ent + (dec ? '.' + dec : '')) || 0;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function init() {
    var carte = document.querySelector('.rogx-config__droite');
    if (!carte || carte.querySelector('.rk')) return;
    var ancre = carte.querySelector('p.rogx-recap-mention') || carte.querySelector('.product-form__buttons');
    if (!ancre) return;
    function lirePrix() { return carte.querySelector('.price-item--sale') || carte.querySelector('.price__regular .price-item--regular') || carte.querySelector('.price-item--regular'); }

    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'rk'; btn.setAttribute('aria-haspopup', 'dialog');
    btn.innerHTML = '<span class="rk-badge">Klarna.</span><span class="rk-txt"><b></b><span></span></span><span class="rk-chev">' + chev + '</span>';
    /* Ligne pleine largeur en bas de la carte (grille à 2 colonnes), mêmes marges que le premier bloc */
    var bloc = ancre;
    while (bloc && bloc.parentElement !== carte) bloc = bloc.parentElement;
    if (bloc) {
      var ligne = document.createElement('div');
      ligne.className = 'rk-bloc';
      var premier = carte.firstElementChild;
      var marge = premier ? getComputedStyle(premier).paddingLeft : '24px';
      ligne.style.paddingLeft = marge; ligne.style.paddingRight = marge;
      ligne.appendChild(btn);
      bloc.insertAdjacentElement('afterend', ligne);
    } else {
      ancre.insertAdjacentElement('afterend', btn);
    }
    var b = btn.querySelector('.rk-txt b'), s = btn.querySelector('.rk-txt span');

    var dernierTotal = -1;
    function maj() {
      var prix = lirePrix();
      var total = prix ? montant(prix.textContent) : 0;
      if (total === dernierTotal) return;
      dernierTotal = total;
      if (cfg.pays === 'FR' && total > 0 && total < PLAFOND && T.t3) {
        var ech = Math.floor(total * 100 / 3) / 100;
        b.textContent = T.t3; s.textContent = T.s3.replace('{x}', fmt.format(ech));
      } else {
        b.textContent = T.tg; s.textContent = T.sg;
      }
    }
    maj();
    /* Le thème remplace l'élément du prix à chaque option : on surveille toute la carte, hors notre bloc */
    var attente = null;
    new MutationObserver(function (liste) {
      for (var i = 0; i < liste.length; i++) {
        var cible = liste[i].target;
        if (cible.nodeType !== 1) cible = cible.parentNode;
        if (cible && cible.closest && cible.closest('.rk-bloc')) continue;
        clearTimeout(attente); attente = setTimeout(maj, 60); return;
      }
    }).observe(carte, { childList: true, characterData: true, subtree: true });

    var voile = null, dernier = null;
    function fermer() {
      if (!voile) return;
      voile.removeAttribute('data-ouvert');
      var v = voile; voile = null;
      document.removeEventListener('keydown', clavier);
      setTimeout(function () { v.remove(); }, 200);
      if (dernier) dernier.focus();
    }
    function clavier(e) { if (e.key === 'Escape') fermer(); }
    btn.addEventListener('click', function () {
      dernier = btn;
      voile = document.createElement('div');
      voile.className = 'rk-voile';
      voile.innerHTML = '<div class="rk-fen" role="dialog" aria-modal="true" aria-labelledby="rk-titre">' +
        '<div class="rk-haut"><h2 id="rk-titre">' + esc(T.h) + '</h2><button type="button" class="rk-x" aria-label="' + esc(T.f) + '">' + croix + '</button></div>' +
        '<p class="rk-chapo">' + esc(T.c) + '</p><ol class="rk-etapes">' +
        '<li><i>1</i><div><b>' + esc(T.e1) + '</b><span>' + esc(T.e1d) + '</span></div></li>' +
        '<li><i>2</i><div><b>' + esc(T.e2) + '</b><span>' + esc(T.e2d) + '</span></div></li>' +
        '<li><i>3</i><div><b>' + esc(T.e3) + '</b><span>' + esc(T.e3d) + '</span></div></li></ol>' +
        '<p class="rk-mention">' + esc(T.m) + '</p></div>';
      document.body.appendChild(voile);
      voile.addEventListener('click', function (e) { if (e.target === voile) fermer(); });
      voile.querySelector('.rk-x').addEventListener('click', fermer);
      document.addEventListener('keydown', clavier);
      requestAnimationFrame(function () { voile.setAttribute('data-ouvert', ''); voile.querySelector('.rk-x').focus(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  setTimeout(init, 1500);
})();
